core.factory('core.baseService', ['$http', '$q', '$window', 'core.objectHelper',
	function($http, $q, $window, objectHelper) {

		function BaseService() {

			this.post = function(url, postData, config) {
				var d = $q.defer();

				// angular doesn't set a Content-Type header if postData is undefined, so we have to make it empty string
				// it only has to be set during development on localhost frontend with remote backend
				if(_.isUndefined(postData)) {
					postData = '';
				}

				$http.post(url, postData, config).success(function(data, status, headers, config) {
					d.resolve(data);
				}).error(function(data, status, headers, config) {
					d.reject(objectHelper.o(HttpResponseVO, { data: data, status: status, headers: headers, config: config }));
				});

				return d.promise;
			};

			this.put = function(url, postData, config) {
				var d = $q.defer();

				// angular doesn't set a Content-Type header if postData is undefined, so we have to make it empty string
				// it only has to be set during development on localhost frontend with remote backend
				if(_.isUndefined(postData)) {
					postData = '';
				}

				$http.put(url, postData, config).success(function(data, status, headers, config) {
					d.resolve(data);
				}).error(function(data, status, headers, config) {
					d.reject(objectHelper.o(HttpResponseVO, { data: data, status: status, headers: headers, config: config }));
				});

				return d.promise;
			};

			this.delete = function(url, postData, config) {
				var d = $q.defer();

				// angular doesn't set a Content-Type header if postData is undefined, so we have to make it empty string
				// it only has to be set during development on localhost frontend with remote backend
				if(_.isUndefined(postData)) {
					postData = '';
				}

				$http.delete(url, postData, config).success(function(data, status, headers, config) {
					d.resolve(data);
				}).error(function(data, status, headers, config) {
					d.reject(objectHelper.o(HttpResponseVO, { data: data, status: status, headers: headers, config: config }));
				});

				return d.promise;
			};

			this.get = function(url, config) {
				var d = $q.defer();

				$http.get(url, config).success(function(data, status, headers, config) {
					d.resolve(data);
				}).error(function(data, status, headers, config) {
					d.reject(objectHelper.o(HttpResponseVO, { data: data, status: status, headers: headers, config: config }));
				});

				return d.promise;
			};

			//this.upload = function(url, file, data) {
			//	var d = $q.defer();
            //
			//	var uploadRequest = {
			//		url: url,
			//		file: file,
			//		data: {
			//			dtoString: JSON.stringify(data)
			//		}
			//	};
            //
			//	$upload.upload(uploadRequest)
			//		.progress(function (event) {
			//			// todo
			//		})
			//		.success(function (data, status, headers, config) {
			//			d.resolve(data);
			//		})
			//		.error(function(data, status, headers, config) {
			//			d.reject(objectHelper.o(HttpResponseVO, { data: data, status: status, headers: headers, config: config }));
			//		});
            //
			//	return d.promise;
			//};

			this.download = function(url) {
				$window.open(url, '_top');
			};

			this.encodeData = function(data) {
				var key, result = [];
				for (key in data) {
					if (data.hasOwnProperty(key)) {
						result.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
					}
				}
				return result.join('&');
			};

			this.createSupressErrorsConfig = function() {
				var supressErrorsConfig = {
					data: {
						suppressErrors: true
					}
				};

				return supressErrorsConfig;
			};
		}

		return new BaseService();
	}
]);
